// チームの地図表示回数の上限。
//
// 有料プランは既定で無制限で、個別に上限を設けたチームだけ
// customMaxMapLoadCount を持つ。無料プランは customMaxMapLoadCount があれば
// それ、無ければ baseFreeMapLoadCount が上限になる。
//
// 有料プランの判定で customMaxMapLoadCount を「数値かどうか」で見ているのは、
// 0 を未設定として扱うと上限0のチームが無制限になってしまうため。

type Input = {
  hasSubscription: boolean;
  baseFreeMapLoadCount: number;
  customMaxMapLoadCount?: number;
};

/** 上限。無制限のときは Infinity を返す。 */
const mapLoadLimit = ({
  hasSubscription,
  baseFreeMapLoadCount,
  customMaxMapLoadCount,
}: Input): number => {
  if (hasSubscription) {
    return typeof customMaxMapLoadCount === 'number'
      ? customMaxMapLoadCount
      : Infinity;
  }

  return customMaxMapLoadCount || baseFreeMapLoadCount;
};

export default mapLoadLimit;
